import React from "react";
import { Dialog } from "@vitalsource/vstui";
import { t } from "../../../core/translate";
import { connect } from "react-redux";
import { actions as modalActions } from "../../../../redux/modals";
import Isvg from "../../../../../vendor/react-inlinesvg";

const LearnerModal = ({ closeModal }) => (
  <Dialog
    open
    key="AutoSharingLearnerModal"
    rootSelector="#bookshelf"
    size="medium"
    onRequestClose={closeModal}
    title={t(`auto-assign.learner-handoff-title`)}
    primaryActionButton={{
      label: t("main-menu.got-it", "Got It"),
      onClick: closeModal
    }}
  >
    <div style={{ textAlign: "center", marginBottom: 20 }}>
      <Isvg className="watkins" src="/img/highlighters_null.svg" />
    </div>
    <p>{t(`auto-assign.learner-handoff-text`)}</p>
  </Dialog>
);

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(modalActions.closeModal())
});

export default connect(
  null,
  mapDispatchToProps
)(LearnerModal);
